import { render } from "./participateDBCDLCMining.vue?vue&type=template&id=874034b6&scoped=true"
import script from "./participateDBCDLCMining.vue?vue&type=script&lang=js"
export * from "./participateDBCDLCMining.vue?vue&type=script&lang=js"

import "./participateDBCDLCMining.vue?vue&type=style&index=0&id=874034b6&lang=scss&scoped=true"

import exportComponent from "/home/ubuntu/dbc-website-build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-874034b6"]])

export default __exports__